module.exports = __webpack_public_path__ + "static/img/logo24.0b9b34f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo24.jpg
// module id = V7Th
// module chunks = 1